import { useCallback, useState } from 'react';

type Props = {
    speedThreshold?: number,
    action: () => void
    actionB?: () => void
    direction?: 'horizontal' | 'vertical'
}

export default function UseSwipe({ speedThreshold, action, actionB, direction }: Props = { action: () => { }, direction: 'vertical' }) {

    const [start, setStart] = useState<number>(0);
    const [timestamp, setTimestamp] = useState<number>(0);

    const getDir = useCallback(() => {
        switch (direction) {
            case 'vertical':
                return 'clientY'
            case 'horizontal':
                return 'clientX'
            default:
                return 'clientY'
        }
    }, [direction])

    const onTouchStart = useCallback((e: any) => {
        setStart(e.changedTouches[0][getDir()]);
        setTimestamp(e.timeStamp)

    }, [getDir])

    const onTouchEnd = useCallback((e: any) => {
        const speed = (e.changedTouches[0][getDir()] - start) / (e.timeStamp - timestamp);

        if (action && Math.abs(speed) > (speedThreshold || 1)) {
            if (speed > 0) {
                action()
            } else {
                actionB ? actionB() : action()
            }
        }

    }, [getDir, start, timestamp, action, speedThreshold, actionB])

    return { onTouchStart, onTouchEnd }

}